// Hurtigfiltrene «Ingen neste steg», «Forfalt» og «Råtner» på Pipeline regnes
// ut i nettleseren (de avhenger av oppgavene og virkedager). Nøklene ligger i
// listefiltrene, så de huskes og kan lagres som visning, men de er ikke
// kolonner og fjernes før spørringen.
export const CLIENT_FILTER_PREFIX = "quick_";

export const stripClientFilters = <P extends { filter?: any }>(
  resource: string,
  params: P,
): P => {
  if (resource !== "deals" || !params?.filter) return params;
  const keys = Object.keys(params.filter);
  if (!keys.some((key) => key.startsWith(CLIENT_FILTER_PREFIX))) return params;
  const filter = Object.fromEntries(
    Object.entries(params.filter).filter(
      ([key]) => !key.startsWith(CLIENT_FILTER_PREFIX),
    ),
  );
  return { ...params, filter };
};
